import React, { useState } from "react";
import { Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";

// import { doc,getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import Signupindustrynav from "../Industry/Signupindustrynav";

const Studentlogin = () => {
  
  // const [user,setUser] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
    error: null,
    loading: false,
  });

  const navigate = useNavigate();
  const { email, password, error, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  // const show = async()=>{
  //   await getDoc(doc(db,"users",auth.currentUser.uid)).then((docSnap) => {
  //     if(docSnap.exists) {
  //       setUser(docSnap.data());
        
  //     }
  //   }); 
  // }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!email || !password) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setData({
        email: "",
        password: "",
        error: null,
        loading: false,
      });
      // const a = user.who;
      navigate("/stuhome")
      // console.log(user.who);
      // if(a==="student"){
      //   navigate("/stuhome")
      //   // console.log(a)
      // }
      // else{
      //   alert("user doesn't exists")
      // }
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };
  return (
    <>
      <Signupindustrynav/>
      <div id="wrapper">
        <div className="form_div">
          <p className="form_label">STUDENT LOGIN</p>
          <form method="post" action="#" onSubmit={handleSubmit}>
            <p> <input
              type="email"
              name="email"
              value={email}
              onChange={handleChange}
              // className="form-group w-100 p-2 inp"
              placeholder="Email..."
              v-model="signup.user"
              required
            /></p>
            <p><input
              type="password"
              name="password"
              value={password}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="password..."
              v-model="signup.pwd"
              required
            /></p>
            {error ? <p className="error">{error}</p> : null}
            {/* <p><input type="submit" defaultValue="LOGIN" /></p> */}
            <button
              type="submit"
              className="btn w-75 btn-submit pr"
              required
              disabled={loading}
              
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <p className="mt-2 dont">
            or don't have an account
           
            <Link
              to="/studentsignup"
              className="linksignup"
              title="open login page"
            >
              {" "}
              Sign Up
            </Link>
          </p>
        </div>
        <br />
        <br />
        <br />
      </div>
     
    </>
  );
};

export default Studentlogin;
